import { Button } from '@tvg/fuse/button';
import { Divider } from '@tvg/fuse/divider';
import { GridItem, GridRow } from '@tvg/fuse/grid';
import { IconFilterList } from '@tvg/fuse/icon/all';
import classNames from 'classnames';
import { useDrawerState } from 'client/state/Drawer';
import { useFacetListState } from 'client/state/FacetList';
import { FILTER_DRAWER_BUTTON_ID } from 'client/utils/consts';
import React, { memo, useCallback, useRef } from 'react';
import ProductsPerPage from './ProductsPerPage/ProductsPerPage';
import ResultCount from './ResultCount';
import SortOrdersDropdown from './SortOrdersDropdown';
import styles from './TopRow.module.css';

function TopRowComponent() {
  const toggleDrawerOpen = useDrawerState((s) => s.toggleDrawerOpen);
  const toggleAriaHidden = useDrawerState((s) => s.toggleAriaHidden);
  const toggleShowViewProducts = useDrawerState((s) => s.toggleShowViewProducts);
  const setActiveFacet = useFacetListState((s) => s.setActiveFacet);
  const filterRef = useRef<HTMLElement>(null);
  // useEffect(() => {
  //   if (isFocusFilterButton) {
  //     setTimeout(() => {
  //       filterRef.current?.focus();
  //       setIsFocusFilterButton(false);
  //     }, 100);
  //   }
  // }, [isFocusFilterButton, setIsFocusFilterButton]);

  const handleFilterClick = useCallback(() => {
    toggleAriaHidden.off();
    toggleShowViewProducts.off();
    toggleDrawerOpen.on();
    setActiveFacet();
  }, [setActiveFacet, toggleAriaHidden, toggleDrawerOpen, toggleShowViewProducts]);

  return (
    <GridRow className={styles.topRow}>
      <GridItem xxs={6} className={styles.topRow__filterButtonContainer}>
        <Button
          id={FILTER_DRAWER_BUTTON_ID}
          icon={<IconFilterList />}
          variant="tertiary"
          size="large"
          fullWidth
          onClick={handleFilterClick} // TODO: Need to set focus into the drawer to hear "Enter the dialog" from the screen reader
          data-testid="toggle-facet__button"
          ref={filterRef}
          className={styles.topRow__filterButton}
        >
          Filter
        </Button>
      </GridItem>

      <GridItem xxs={6} className={classNames(styles.topRow__filterButtonContainer, 'filter-button-row')}>
        <SortOrdersDropdown showInMobile />
      </GridItem>

      <GridItem xxs={12} className={styles['topRow__dividerContainer--mobile']}>
        <Divider className="results-divider-mobile" />
      </GridItem>

      <GridItem xxs={12} l={12}>
        <GridRow>
          <GridItem xxs={12} l={8}>
            <div className={styles.topRow__resultWrapper}>
              <ResultCount position="top" />
              <ProductsPerPage position="top" />
            </div>
          </GridItem>
          <GridItem l={4}>
            <SortOrdersDropdown />
          </GridItem>
        </GridRow>
      </GridItem>

      <GridItem xxs={12} className={styles['topRow__dividerContainer--desktop']}>
        <Divider className="results-divider-desktop" />
      </GridItem>
    </GridRow>
  );
}

export const TopRow = memo(TopRowComponent);
